import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { debounceTime, distinctUntilChanged, map, Observable, Subscription } from "rxjs";

import { APIResults } from "src/app/sharedinterfaces";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-dashboard-default",
	templateUrl: "./dashboard-default.component.html",
	styleUrls: ["./dashboard-default.component.scss"]
})
export class DashboardDefaultComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	public fleets: APIResults.Fleet[];
	public orgs: APIResults.Organization[] = [];
	public brand = BrandVars;
	public searchText = "";
	private searchables = [];

	constructor(private router: Router, private fleettracker: FleetTrackerService, public api: ApiService) { }

	ngOnInit() {
		// TODO: fix up someday
		/* eslint-disable-next-line @typescript-eslint/no-this-alias */
		const me = this;
		me.subscriptions.push(me.fleettracker.fleets.subscribe(fleets => {
			me.orgs = [];
			// If fleets have orgs (admin) sort them by org
			if (fleets) {
				for (const fleet of fleets) {
					if (fleet.organization_id) {
						let fleetorg = me.orgs.find(item => item.organization_id === fleet.organization_id);
						if (!fleetorg) {
							fleetorg = { organization_id: fleet.organization_id, name: fleet.organization_name, fleets: [] };
							me.orgs.push(fleetorg);
						}
						fleetorg.fleets.push(fleet);
					}
				}
			}
			me.fleets = fleets;
			// Generate searchable entries
			me.searchables = [];
			if (fleets) {
				for (const fleet of fleets) {
					me.searchables.push({ category: "Fleet", url: "/dash/fleet/" + fleet.fleet_id, name: fleet.fleet_name });
					if (fleet.assets) {
						for (const asset of fleet.assets) {
							me.searchables.push({ category: "Asset", url: "/dash/fleet/" + fleet.fleet_id + "/asset/" + asset.asset_id, name: asset.asset_name, serial: asset.asset_serial_number, obcu: asset.obcu_serial_number });
						}
					}
				}
			}
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	searchFunc = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			map(term => term.length < 2 ? []
				: this.searchables.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1) || (v.serial && v.serial.toLowerCase().indexOf(term.toLowerCase()) > -1) || (v.obcu && v.obcu.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
		);

	searchNav = (searchable) => {
		this.router.navigate([searchable.url]);
	}
}
